import React, { useState, createContext, useContext } from 'react';

import {
  ApprovePuzzleModal,
  CropperModal,
  DeclineModal,
  DeleteModal,
  UpdatePasswordModal,
} from '../modals';
import CreateEditDailyPuzzle from '../modals/dailyPuzzles/CreateEditDailyPuzzle';
import { EditCollectionModal } from '../modals/collections';
import { EditColoringGridCollectionModal } from '../modals/coloring-grid-collections';
import ConfirmationModal from '../modules/dashboard/pages/PayoutsScreen/Modals/ConfirmationModal';
import CreatePayoutModal from '../modules/dashboard/pages/PayoutsScreen/Modals/CreatePayoutModal';
import PayoutDetailsModal from '../modules/dashboard/pages/PayoutsScreen/Modals/PayoutDetailsModal';
import { AddMemberModal } from '../modules/dashboard/pages/UsersAndPermissionsScreen/Components';
import { DialogModal } from '../shared/Components/Modals/DialogModal';

export const MODAL_TYPES = {
  DIALOG_MODAL: 'Dialog modal',
  EDIT_PUZZLE_MODAL: 'Edit puzzle modal',
  DECLINE_MODAL: 'Decline modal',
  APPROVE_PUZZLE_MODAL: 'Approve puzzle modal',
  DELETE_PUZZLE_MODAL: 'Delete puzzle modal',
  EDIT_COLLECTION_MODAL: 'Edit collection modal',
  EDIT_COLORING_GRID_COLLECTION_MODAL: 'Edit coloring grid collection modal',
  ADD_MEMBER_MODAL: 'Add member modal',
  CROPPER_MODAL: 'Cropper Modal',
  UPDATE_PASSWORD_MODAL: 'Update Password Modal',
  PAYOUT_DETAILED_VIEW: 'Payout Detailed View',
  CREATE_PAYOUT_MODAL: 'Create Payout',
  CONFIRMATION_MODAL: 'Confirmation Modal',
  CREATE_EDIT_DAILY_PUZZLE: 'Create and Edit Daily Puzzle Modal',
};

const MODAL_COMPONENTS: any = {
  [MODAL_TYPES.DIALOG_MODAL]: DialogModal,
  [MODAL_TYPES.DECLINE_MODAL]: DeclineModal,
  [MODAL_TYPES.APPROVE_PUZZLE_MODAL]: ApprovePuzzleModal,
  [MODAL_TYPES.DELETE_PUZZLE_MODAL]: DeleteModal,
  [MODAL_TYPES.EDIT_COLLECTION_MODAL]: EditCollectionModal,
  [MODAL_TYPES.EDIT_COLORING_GRID_COLLECTION_MODAL]: EditColoringGridCollectionModal,
  [MODAL_TYPES.ADD_MEMBER_MODAL]: AddMemberModal,
  [MODAL_TYPES.CROPPER_MODAL]: CropperModal,
  [MODAL_TYPES.UPDATE_PASSWORD_MODAL]: UpdatePasswordModal,
  [MODAL_TYPES.PAYOUT_DETAILED_VIEW]: PayoutDetailsModal,
  [MODAL_TYPES.CREATE_PAYOUT_MODAL]: CreatePayoutModal,
  [MODAL_TYPES.CONFIRMATION_MODAL]: ConfirmationModal,
  [MODAL_TYPES.CREATE_EDIT_DAILY_PUZZLE]: CreateEditDailyPuzzle,
};

type ContextType = {
  showModal: (modalType: string, modalProps?: any) => void;
  hideModal: () => void;
  store: any;
};

const initialState: ContextType = {
  showModal: () => {},
  hideModal: () => {},
  store: {},
};

const GlobalModalContext = createContext(initialState);
export const useGlobalModalContext = () => useContext(GlobalModalContext);

export const GlobalModal: React.FC = ({ children }) => {
  const [store, setStore] = useState<any>();
  const { modalType, modalProps }: any = store || {};

  const showModal = (modalType: string, modalProps: any = {}) => {
    setStore({
      ...store,
      modalType,
      modalProps,
    });
  };

  const hideModal = () => {
    setStore({
      ...store,
      modalType: null,
      modalProps: {},
    });
  };

  const renderComponent = () => {
    const ModalComponent = MODAL_COMPONENTS[modalType];
    if (!modalType || !ModalComponent) {
      return null;
    }
    return <ModalComponent {...modalProps} />;
  };

  return (
    <GlobalModalContext.Provider value={{ store, showModal, hideModal }}>
      {renderComponent()}
      {children}
    </GlobalModalContext.Provider>
  );
};
